module.exports = __webpack_public_path__ + "img/email-header-wellness@2x.24470802.png";